import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import pq from 'pqgrid';
import * as $ from 'jquery';
import { StagingItem } from '../models/StagingItem';
import { ScheduleParameters } from '../models/ScheduleParameters';
import { PqgridComponent } from '../pqgrid/pqgrid.component';
import { ScheduleDataService } from '../services/schedule-data.service';
import { LocationType, StagingType } from '../models/Enums';
import { ContractParameters } from '../models/ContractParameters';
import { timer } from 'rxjs';
import { DeleteComponent } from '../delete-confirm/delete-confirm.component';
import { DeleteParameters } from '../models/DeleteParameters';

@Component({
    selector: 'staging',
    templateUrl: 'staging.component.html',
    styles: [],
    standalone: false
})
export class StagingComponent implements OnInit, OnChanges {
    deleteItemParams: DeleteParameters;

    constructor(private _scheduleDataService: ScheduleDataService) { }

    @ViewChild('childComponent') childComponent!: DeleteComponent;
    @ViewChild('stagingGrid') stagingGrid: PqgridComponent;
    @Input() scheduleParameters: ScheduleParameters = new ScheduleParameters();
    @Input() refreshGrid: boolean;
    @Output() schedulesChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() refreshDataComplete: EventEmitter<boolean> = new EventEmitter<boolean>();

    contractParameters: ContractParameters = new ContractParameters();

    stagingItems: StagingItem[] = [];
    defaultSchedules: StagingItem[] = [];
    statusMessage: string = '';
    creatingSchedules: boolean = false;
    addingDefaultSchedule: boolean = false;    
    errorMessage: string = '';

    stagingColumns = [
        {
            title: "<input type='checkbox' style='margin-left: 10px;'/>",
            cb: {
                all: true, //header checkbox to affect checkboxes on all pages.
                header: true
            },
            width: 30, type: "checkbox", dataIndx: "include", resizable: false, editable: true, align: 'center',
            sortable: false, nodrag: true, dataType: "bool", editor: false
        },
        {
            title: "", width: 30, dataType: "html", resizable: false, editable: false, sortable: false, nodrag: true,
            render: function (ui) {
                return '<a href="#" class="grid-icon-btn contracts-btn" data-bs-toggle="modal" data-bs-target="#contractsModal" title="view contracts"><i class="fa-solid fa-file-contract fa-lg"></i></i></a>' +
                    '<a href="#" class="grid-icon-btn delete-btn" data-bs-toggle="modal" data-bs-target="#scheduleStagingDeleteModal" title="delete default schedule"><i class="fa-solid fa-trash-can fa-lg"></i></a>';
            }
        },
        {
            title: "Loads", width: 90, dataType: "integer", format: "#,###", dataIndx: "scheduleLoads", editable: true, sortable: false,
            style: { 'background-color': '#fff2cc' }
        },
        {
            title: "Unload#", width: 100, dataType: "string", dataIndx: "loadNumber", editable: true, sortable: false,
            style: { 'background-color': '#fff2cc' }
        },
        { title: "Loc", width: 70, dataType: "string", dataIndx: "locCode", editable: false, hidden: true, filter: { crules: [{ condition: "begin" }] } },
        { title: "Customer", width: 250, dataType: "string", dataIndx: "customerName", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Cust Code", width: 120, dataType: "string", dataIndx: "customerCode", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Destination", width: 300, dataType: "string", dataIndx: "locationName", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Dest Code", width: 120, dataType: "string", dataIndx: "locationCode", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "City", width: 150, dataType: "string", dataIndx: "locationCity", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Comm", width: 100, dataType: "string", dataIndx: "commodityCode", editable: false, filter: { crules: [{ condition: "begin" }] } },
        { title: "F/D", width: 90, dataType: "string", dataIndx: "deliveryTerm", editable: false, filter: { crules: [{ condition: "range" }] } },
        {
            title: "Quantity", width: 120, dataType: "string", dataIndx: "quantity", editable: false, sortable: true,
            align: "right",
            sortType: function (row1, row2, dataIndx) {
                function parseQuantityAndUnits(value) {
                    const matches = value.match(/([\d,]+)?\s*(\w+)/);
                    if (matches) {
                        const quantityStr = matches[1]?.replace(/,/g, '') || '0';
                        const quantity = parseInt(quantityStr, 10);
                        const unit = matches[2].toUpperCase();
                        return [quantity, unit];
                    }

                    return [0, value.toUpperCase()];
                }

                const value1 = row1[dataIndx];
                const value2 = row2[dataIndx];

                const [quanitity1, unit1] = parseQuantityAndUnits(value1);
                const [quanitity2, unit2] = parseQuantityAndUnits(value2);

                if (unit1 !== unit2) {
                    return unit1.localeCompare(unit2);
                }

                return quanitity1 - quanitity2;

            }
        },
        { title: "Loads", width: 100, dataType: "integer", dataIndx: "loads", editable: false },
        { title: "Open Loads", width: 120, dataType: "integer", dataIndx: "openLoads", editable: false }
    ];
    //dimsRelativeTo: '#tabContent',

    stagingOptions: pq.gridT.options = {
        menuIcon: false,
        showTop: false,
        roundCorners: true,
        reactive: true,
        locale: "en",
        height: "flex",
        fillHandle: "",
        freezeCols: 1,
        resizable: true,
        numberCell: {
            show: false
        },
        colModel: this.stagingColumns,
        animModel: {
            on: true
        },
        dataModel: {
            data: []
        },
        editModel: {
            clicksToEdit: 1
        },
        sortModel: {
            cancel: true,
            type: "local",
            single: false,
            space: false,
        },
        filterModel: {
            header: true,
            menuIcon: false
        },
        postRenderInterval: -1,

    };

    clearFilters() {
        this.stagingGrid.grid.reset({ filter: true });
    }

    clearSorting() {
        this.stagingGrid.grid.reset({ sort: true });
    }



    get stagingType(): StagingType {
        return this.scheduleParameters.stagingType;
    }
    set stagingType(value: StagingType) {
        this.scheduleParameters.stagingType = value;
        if (value == StagingType.Contracts) {
            this.stagingOptions.dataModel.data = this.stagingItems;
        }
        else {
            this.stagingOptions.dataModel.data = this.defaultSchedules;
        }
    }

    createSchedules() {
        let data = this.stagingOptions.dataModel.data as StagingItem[];
        let stagingItems: StagingItem[] = data.filter(item => item.include)

        if (stagingItems.length == 0) {
            this.statusMessage = 'you must select staging items to create schedules for'
            timer(5000).subscribe(n => this.statusMessage = '');
            return;
        }
        else {
            this.statusMessage = 'creating schedules...'
        }

        this.creatingSchedules = true;
        let parms = { ...this.scheduleParameters };
        parms.stagingItems = stagingItems;
        this._scheduleDataService.createStagingSchedules(parms).subscribe({
            next: results => {
                if (results.createdCount == 0) {
                    this.statusMessage = 'selected schedules already exist'
                }
                else {
                    if (results.createdCount == 1) {
                        this.statusMessage = '1 schedule was created';
                    }
                    else {
                        this.statusMessage = results.createdCount + ' schedules were created';
                    }
                }
                timer(5000).subscribe(n => this.statusMessage = '');
                this.stagingOptions.dataModel.data = results.stagingItems;
                this.schedulesChanged.emit(true);
                this.creatingSchedules = false;
            },
            error: err => {
                this.errorMessage = err;
                this.statusMessage = '';
                this.creatingSchedules = false;
            }
        });
    }

    addDefaultSchedules() {
        let data = this.stagingOptions.dataModel.data as StagingItem[];
        let stagingItems: StagingItem[] = data.filter(item => item.include)

        if (stagingItems.length == 0) {
            this.statusMessage = 'you must select staging items to add to default schedules'
            timer(5000).subscribe(n => this.statusMessage = '');
            return;
        }
        else {
            this.statusMessage = 'adding...'
        }

        this.addingDefaultSchedule = true;
        let parms = { ...this.scheduleParameters };
        parms.stagingItems = stagingItems;
        this._scheduleDataService.createDefaultSchedules(parms).subscribe({
            next: results => {
                if (results.createdCount == 0) {
                    this.statusMessage = 'default schedules already exist'
                }
                else {
                    if (results.createdCount == 1) {
                        this.statusMessage = '1 item ';
                    }
                    else {
                        this.statusMessage = results.createdCount + ' items ';
                    }
                    this.statusMessage += 'added to default schedules';
                }
                this.refreshStagingData();
                timer(5000).subscribe(n => this.statusMessage = '');
                this.addingDefaultSchedule = false;
            },
            error: err => {
                this.errorMessage = err;
                this.statusMessage = '';
                this.addingDefaultSchedule = false;
            }
        });
    }


    renameColumns() {
        let scheduleType = 'Destination';
        let dispatchType = 'Origin';
        let scheduleCode = 'Dest Code';
        let dispatchCode = 'Origin Code';
        let scheduleNum = 'Unload#';
        let dispatchNum = 'Load#';
        if (this.scheduleParameters.locationType === LocationType.Origin) {
            scheduleType = 'Origin';
            dispatchType = 'Destination';
            scheduleCode = 'Origin Code';
            dispatchCode = 'Dest Code';
            scheduleNum = 'Load#';
            dispatchNum = 'Unload#';
        }
        for (let column of this.stagingColumns) {
            if (column.title == dispatchType) {
                column.title = scheduleType;
            }
            if (column.title == dispatchCode) {
                column.title = scheduleCode;
            }
            if (column.title == dispatchNum) {
                column.title = scheduleNum;
            }
            if (column.title == 'Loc') {
                //only show loc column if loc group is selected
                if (this.scheduleParameters.locCode.startsWith('G')) {
                    column.hidden = false;
                }
                else {
                    column.hidden = true;
                }
            }
        }
    }

    refreshStagingData() {
        if (this.scheduleParameters.locCode.length === 0) {
            return;
        }
        this.renameColumns();
        this.stagingOptions.dataModel.data = [];

        this._scheduleDataService.getStagingItems(this.scheduleParameters).subscribe({
            next: data => {
                this.stagingItems = data;                
                if (this.scheduleParameters.stagingType == StagingType.Contracts) {
                    this.stagingOptions.dataModel.data = data;
                }
                this.refreshDataComplete.emit(true);
            },
            error: err => this.errorMessage = err
        });

        this._scheduleDataService.getDefaultSchedules(this.scheduleParameters).subscribe({
            next: data => {
                this.defaultSchedules = data;
                if (this.scheduleParameters.stagingType == StagingType.Defaults) {
                    this.stagingOptions.dataModel.data = data;
                }
            },
            error: err => this.errorMessage = err
        });
    }

    //check to include if number is entered for loads
    gridStagingChange(evt, ui) {
        let loads: number = ui.updateList[0].rowData.scheduleLoads;
        if (!isNaN(loads) && loads > 0) {
            let index = ui.updateList[0].rowIndx;
            let stagingItem = this.stagingOptions.dataModel.data[index] as StagingItem;
            if (stagingItem) {
                stagingItem.include = true;
                //this.scheduleGrid.grid.refreshCell({ rowIndx: index, dataIndx: 'include' });
            }
        }
    }

    showContracts(rowData) {

        let parms = new ContractParameters();
        parms.locCode = this.scheduleParameters.locCode;
        parms.locationType = this.scheduleParameters.locationType;
        parms.shipThroughDate = this.scheduleParameters.shipThroughDate;
        parms.commodityCode = rowData.commodityCode;
        parms.customerId = rowData.customerId;
        parms.locationId = rowData.locationId;
        parms.deliveryTerm = rowData.deliveryTerm;
        parms.customerName = rowData.customerName;
        parms.locationName = rowData.locationName;
        parms.locationCity = rowData.locationCity;
        parms.commodity = rowData.commodityCode;
        this.contractParameters = { ...parms };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['scheduleParameters']) {
            this.refreshStagingData();
        }
        if (changes['refreshGrid']) {
            if (this.stagingGrid) {
                this.stagingGrid.grid.refresh();
            }
        }
        this.setGridHeight();
    }

    ngOnInit(): void {
        let self = this;

        //hook up change event on grid
        this.stagingOptions.change = function (evt, ui) {
            self.gridStagingChange(evt, ui);
        }

        //hook up contracts button click
        this.stagingOptions.colModel[1].postRender = function (ui) {
            var rowData = ui.rowData;
            var $cell = this.getCell(ui);
            var $contractsBtn = $cell.find('.contracts-btn');
            var $deleteBtn = $cell.find('.delete-btn');

            if (self.scheduleParameters.stagingType == StagingType.Contracts) {
                $contractsBtn.on('click', function () {
                    self.showContracts(rowData);
                });
                $deleteBtn.hide();
            }
            else {
                $deleteBtn.on('click', function () {
                    const customerName = rowData.customerName;
                    const locationName = rowData.locationName;
                    var title = `Are you sure you want to delete the schedule ${customerName} @ ${locationName}?`;
                    const scheduleId = rowData.scheduleDefaultId;
                    self.deleteDefaultSchedule(scheduleId, title);
                });
                $contractsBtn.hide();
            }
        };
    }



    deleteItem(event: boolean, deleteItem: DeleteParameters) {
        if (event) {
            this._scheduleDataService.deleteDefaultSchedule(deleteItem.scheduleId).subscribe({
                next: result => {
                    if (result) {
                        //add code to reresh the grid
                        //this.stagingGrid.grid.refreshDataAndView();
                        this.stagingOptions.dataModel.data = this.defaultSchedules.filter(x => x.scheduleDefaultId != deleteItem.scheduleId);
                        this.deleteItemParams = new DeleteParameters();
                        this.childComponent.close();
                    }
                },
                error: err => this.errorMessage = err
            });
        }

        return false;
    }


    deleteDefaultSchedule(scheduleId: number, title: string) {
        let parms = new DeleteParameters()
        parms.scheduleId = scheduleId;
        parms.title = title;
        this.deleteItemParams = parms;
    }


    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.setGridHeight();
    }

    setGridHeight() {
        if (this.stagingGrid) {
            let gridPosition = this.stagingGrid.div.nativeElement.getBoundingClientRect();
            this.stagingOptions.height = window.innerHeight - gridPosition.top - 15;
        }
    }


}
